import React from 'react';
import PropTypes from 'prop-types';

const styles = {
	links: { color: '#284263' },
}

const CHUrlField = ({ source, source_disp, record = {} }) => <a style={styles.links} target="_blank" href={record['website_url']+'/link/'+record['link_key']}>{record['website_url']+'/link/'+record['link_key']}</a>;

CHUrlField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default CHUrlField;


// WEBPACK FOOTER //
// ./src/utils/CHOutgoingLinkField.js